// extracted by mini-css-extract-plugin
export default {"option":"MultipleChoiceSettings_option__i2Ncn","icon":"MultipleChoiceSettings_icon__yeqKH","input":"MultipleChoiceSettings_input__VXiXJ"};